import { Component, inject } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';

import { ChrComponentsModule } from '@ciphr-design-system/angular';

import { CollectionFilteringStore } from '../../../state/collection-filtering.store';

@Component({
  selector: 'ciphr-collection-filters-drawer-toggle-button',
  standalone: true,
  imports: [TranslocoDirective, ChrComponentsModule],
  templateUrl: './collection-filters-drawer-toggle-button.component.html',
})
export class CollectionFiltersDrawerToggleButtonComponent {
  private readonly collectionFilteringStore = inject(CollectionFilteringStore);

  toggleFiltersDrawer(): void {
    this.collectionFilteringStore.toggleDrawer();
  }
}
